
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import { isEqual } from "lodash";
import { productQueryBuilder } from "@/utils";
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState({
      compareList: (state) => state.comparison.compareList,
    }),
  },
  methods: {
    productQueryBuilder,
    ...mapMutations({
      setCompareList: "comparison/SET_COMPARE_LIST",
    }),
    async onDelete(item) {
      try {
        const comparisonUniqueId =
          this.$store.state.localStorage.comparlist_unique_id;
        const filteredCompareList = this.compareList.filter(
          (el) =>
            !isEqual(
              { sku: el.sku, engraving: el.engraving },
              { engraving: item.engraving, sku: item.sku }
            )
        );
        const { data } = await this.$api.comparison.addItem({
          unique_id: comparisonUniqueId,
          baggage: filteredCompareList,
        });
        this.setCompareList(data.data.baggage);
      } catch (err) {
        console.log("err - ", err?.response?.data?.errors);
      }
    },
  },
};
